module.exports = __webpack_public_path__ + "static/media/4.014257d5.png";